export const marketReportSamples = [
  {
    name: 'Chicago Regional Report',
    filters: {
      year_built: {
        max: null,
        min: 1900
      },
      coordinates: [
        [
          [
            [-87.640518570262, 41.9534484589315],
            [-87.6405402304401, 41.9535036224952],
            [-87.6406427884011, 41.9537648116878],
            [-87.640983788883, 41.9546318121878],
            [-87.6410047887994, 41.9547288122338],
            [-87.6410060078132, 41.9547394763643],
            [-87.6410171406345, 41.9547396921454],
            [-87.6410597612032, 41.9547398658392],
            [-87.6418714896737, 41.9547431787138],
            [-87.6440477410945, 41.9547520631492],
            [-87.6441456125447, 41.9546667126608],
            [-87.644276677643, 41.9546658882825],
            [-87.6445456763582, 41.9546538886999],
            [-87.6446666776303, 41.9546518892147],
            [-87.6448066782707, 41.9546498883933],
            [-87.6449166778756, 41.9546558888532],
            [-87.6450976776255, 41.9546498883933],
            [-87.6452386780908, 41.9546488883165],
            [-87.6459036784378, 41.9546278880379],
            [-87.6466116766458, 41.9546088879072],
            [-87.6467286768217, 41.9546128888845],
            [-87.64714367872, 41.9546018880334],
            [-87.6479246785196, 41.9545888876931],
            [-87.6496896794067, 41.9545538889735],
            [-87.6504896785745, 41.954537887052],
            [-87.652109680595, 41.9545218871306],
            [-87.6545206806641, 41.9544828873889],
            [-87.6561046818013, 41.9544648872946],
            [-87.6567226813942, 41.9544578880731],
            [-87.65683495733, 41.9544594807183],
            [-87.6568636818595, 41.9544598868963],
            [-87.6569816818603, 41.9544598868963],
            [-87.6592246825983, 41.9544338874913],
            [-87.6622135428386, 41.9543818064784],
            [-87.6622157670672, 41.9543778649436],
            [-87.6633774117988, 41.9543778649436],
            [-87.6638419575817, 41.9543732259573],
            [-87.6653361532415, 41.9543538723484],
            [-87.6670365329203, 41.9543263711073],
            [-87.6682733217254, 41.9543126752631],
            [-87.6689757692432, 41.9543078645812],
            [-87.6689781165411, 41.9543933411448],
            [-87.6691157689853, 41.9542878649407],
            [-87.6699729243615, 41.9542228268174],
            [-87.671024463487, 41.9542029955009],
            [-87.6718341231374, 41.9541928864374],
            [-87.6729677251607, 41.9541821413803],
            [-87.6737972061379, 41.9541719715201],
            [-87.6737976858382, 41.9541648874229],
            [-87.6737436863099, 41.9524098876395],
            [-87.6737106849013, 41.9505848858571],
            [-87.6736736850914, 41.9487558852637],
            [-87.673655685548, 41.9486468847681],
            [-87.6736216223307, 41.9471633488216],
            [-87.6736176859132, 41.9469918857782],
            [-87.6736166699186, 41.9469501039937],
            [-87.6733045889007, 41.9464127157125],
            [-87.6730047096993, 41.9458970048998],
            [-87.6727945173975, 41.9455968831887],
            [-87.6721032386336, 41.9446098447196],
            [-87.6715167276862, 41.943791887738],
            [-87.6705875076614, 41.9424655309642],
            [-87.669565993826, 41.9409860681693],
            [-87.6690185407289, 41.9402159456282],
            [-87.6686557677795, 41.9396878615511],
            [-87.6705385234273, 41.9396758511305],
            [-87.6712628916348, 41.9396608397721],
            [-87.6716792787352, 41.9396522104946],
            [-87.6723998623404, 41.939637279316],
            [-87.6734386435922, 41.9396287088379],
            [-87.673445737588, 41.9396284001243],
            [-87.688143910283, 41.939497023625],
            [-87.688310473208, 41.9467305859835],
            [-87.6961980254574, 41.9467034188626],
            [-87.6961743404766, 41.9465613079259],
            [-87.6960538521425, 41.9459320918909],
            [-87.6960404636515, 41.9455438521965],
            [-87.6959601389937, 41.9451823870489],
            [-87.6957459384092, 41.9443925215795],
            [-87.6956388367694, 41.9437633048532],
            [-87.6955451236207, 41.9432813521077],
            [-87.6954647980646, 41.9427190739775],
            [-87.6953175345451, 41.9423977726354],
            [-87.6948088069216, 41.9417685576056],
            [-87.6942331413347, 41.9411125657763],
            [-87.6939520018885, 41.9407109394177],
            [-87.6937110261186, 41.9404164122146],
            [-87.6933093983382, 41.9401084974755],
            [-87.6930550349756, 41.9398273584048],
            [-87.6925061445741, 41.9394926695508],
            [-87.6921312928774, 41.9391713679881],
            [-87.6917430526896, 41.9389973295226],
            [-87.6914351380581, 41.9387965150099],
            [-87.6911673871028, 41.9384752146172],
            [-87.6908996343509, 41.9381806871112],
            [-87.6907523717297, 41.9378995482283],
            [-87.6906452709883, 41.9375916340326],
            [-87.6905783330249, 41.9372301692429],
            [-87.6904310695054, 41.9369624190227],
            [-87.6901633185501, 41.9367348290149],
            [-87.6898687915112, 41.936614341588],
            [-87.6894403894438, 41.9365340160648],
            [-87.6890387616634, 41.9364938532653],
            [-87.6885701968179, 41.9363733653831],
            [-87.6881685699359, 41.9363064272012],
            [-87.6878204925262, 41.9360922265517],
            [-87.6874188656442, 41.9356905993137],
            [-87.6871109510126, 41.9352889715512],
            [-87.6869503007987, 41.9350346084438],
            [-87.6865352854256, 41.9345124931718],
            [-87.6862943087574, 41.9343384540207],
            [-87.6860131702095, 41.9340707030208],
            [-87.6856650927998, 41.9339100521486],
            [-87.6851162032966, 41.9336824632772],
            [-87.6846744127382, 41.9336155249441],
            [-87.6842058478927, 41.9335485885456],
            [-87.6840164533864, 41.9335097376956],
            [-87.6836837326766, 41.9334414873551],
            [-87.6833356552669, 41.9333209990527],
            [-87.6831348413767, 41.9328390455717],
            [-87.6829029709305, 41.9323963837438],
            [-87.6828403143378, 41.9322767682566],
            [-87.6828164883215, 41.9322370558759],
            [-87.6827175613508, 41.9322386798177],
            [-87.6825279701135, 41.9322418040676],
            [-87.6823405887317, 41.9322442546824],
            [-87.6820820176603, 41.9322471236457],
            [-87.6815849411861, 41.9322529745129],
            [-87.6812904159438, 41.9322567643776],
            [-87.6809935146575, 41.9322595785407],
            [-87.6806980803202, 41.9322626459851],
            [-87.6804246987247, 41.9322654835381],
            [-87.6800409025027, 41.9322699410222],
            [-87.6795438197402, 41.9322761681336],
            [-87.6792227223318, 41.9322802126147],
            [-87.6788657713638, 41.9322828450024],
            [-87.6787568703985, 41.9322836489533],
            [-87.6785700324975, 41.9322870017556],
            [-87.6782523837215, 41.9322916904659],
            [-87.6782228174705, 41.9322919163473],
            [-87.6782147425144, 41.9322853183374],
            [-87.6781106852652, 41.9322858817045],
            [-87.6762636852607, 41.9323028816194],
            [-87.6756636843127, 41.9323248823281],
            [-87.6751456842788, 41.9323278822723],
            [-87.6747346843751, 41.9323298824578],
            [-87.6738926844762, 41.932334882587],
            [-87.6734416852878, 41.9323398292529],
            [-87.6733694760103, 41.9323405683791],
            [-87.6720696829645, 41.9323538833419],
            [-87.6708236828344, 41.9323798823961],
            [-87.6695916829481, 41.9323838827637],
            [-87.6683886824759, 41.9324028821674],
            [-87.6683833689409, 41.9324030525806],
            [-87.6682636819041, 41.9324068825336],
            [-87.6679056826021, 41.9324138828396],
            [-87.6671746821329, 41.9324278827811],
            [-87.6659736822087, 41.9324438829014],
            [-87.6647526803965, 41.9324658828932],
            [-87.6635568844128, 41.93249485377],
            [-87.6623446807004, 41.9325098841907],
            [-87.6613516811887, 41.9325268840459],
            [-87.6611216792383, 41.9325318834914],
            [-87.6598996793977, 41.9325398828708],
            [-87.6587036794964, 41.9325698842099],
            [-87.6574456796709, 41.932595883176],
            [-87.6562746789856, 41.9326048836381],
            [-87.6558336780463, 41.9326078849057],
            [-87.6551716789708, 41.9326188835377],
            [-87.6538516774243, 41.9326418838911],
            [-87.6531376775718, 41.9326538829391],
            [-87.652626678109, 41.9326638838147],
            [-87.6514236776367, 41.9326828838032],
            [-87.6502196755429, 41.9327048850492],
            [-87.6489967477426, 41.9327249308895],
            [-87.649009254088, 41.9331326621555],
            [-87.6490386218113, 41.9340222741744],
            [-87.6490706027337, 41.9349980713464],
            [-87.6491105768655, 41.9358841797709],
            [-87.6491357620328, 41.9368570843782],
            [-87.6492059851352, 41.9386364132918],
            [-87.6492380208549, 41.9394452050439],
            [-87.649266086021, 41.9405792430757],
            [-87.6492887181763, 41.9413075423371],
            [-87.6493289357515, 41.9422030726956],
            [-87.6493523907636, 41.9430094979674],
            [-87.6493737329381, 41.9439805532989],
            [-87.6494048739358, 41.9451203389772],
            [-87.6494259780567, 41.9459277616412],
            [-87.6494473013666, 41.9467355682803],
            [-87.6494997324365, 41.9481910918312],
            [-87.6495462732531, 41.9494851975154],
            [-87.6495657622031, 41.950620365113],
            [-87.6495994292633, 41.951836208337],
            [-87.6496257624776, 41.952757865489],
            [-87.6485978436542, 41.9528169418868],
            [-87.6469028781216, 41.9529119698735],
            [-87.6457368244586, 41.9529810271161],
            [-87.6410580840486, 41.9534009132885],
            [-87.6406102253704, 41.9534411061911],
            [-87.6405382029425, 41.9534475683988],
            [-87.640518570262, 41.9534484589315],
            [-87.640518570262, 41.9534484589315]
          ]
        ]
      ],
      number_units: {
        max: null,
        min: null
      },
      number_stories: {
        max: null,
        min: null
      }
    }
  }
]

export const propertyReportSamples = [
  {
    name: 'Sample - Downtown High Rise',
    subject: {
      id: '0e628031-57b8-5394-821d-13779318fef4',
      lat: 41.88651,
      lon: -87.63141,
      city: 'Chicago',
      state: 'IL',
      zip_code: '60601',
      year_built: 2014,
      number_units: 505,
      building_name: 'OneEleven',
      street_address: '111 West Wacker Drive',
      building_name_alias: ['OneEleven'],
      street_address_alias: ['111 West Wacker', '111 West Wacker Drive']
    },
    comparable_addresses: [
      {
        id: '03fbabc5-23ab-5bd6-889c-43f88e239230',
        lat: 41.88979,
        lon: -87.63071,
        city: 'Chicago',
        state: 'IL',
        zip_code: '60654',
        year_built: 2012,
        number_units: 409,
        building_name: 'AMLI River North',
        street_address: '71 West Hubbard Street',
        building_name_alias: ['AMLI River North'],
        street_address_alias: ['71 West Hubbard', '71 Hubbard', '71 West Hubbard Street']
      },
      {
        id: '15599d82-be17-5b45-8003-0738de431104',
        lat: 41.88761,
        lon: -87.63816,
        city: 'Chicago',
        state: 'IL',
        zip_code: '60654',
        year_built: 2015,
        number_units: 529,
        building_name: 'Wolf Point West',
        street_address: '343 West Wolf Point Plaza',
        building_name_alias: ['343 West Wolf Point Plaza', 'Wolf Point West'],
        street_address_alias: ['343 West Wolf Point Plaza']
      },
      {
        id: '4e20d96a-d08b-5508-9ba7-259aee7b5de0',
        lat: 41.88543,
        lon: -87.62549,
        city: 'Chicago',
        state: 'IL',
        zip_code: '60601',
        year_built: 2014,
        number_units: 332,
        building_name: '73 East Lake',
        street_address: '73 East Lake Street',
        building_name_alias: ['73 East Lake'],
        street_address_alias: ['73 East Lake Street', '73 Lake Street']
      },
      {
        id: 'c9ed4f1e-3f39-5e4d-b34d-9dd958c6ec66',
        lat: 41.89045,
        lon: -87.63865,
        city: 'Chicago',
        state: 'IL',
        zip_code: '60654',
        year_built: 2013,
        number_units: 450,
        building_name: 'Hubbard Place',
        street_address: '360 West Hubbard Street',
        building_name_alias: ['Hubbard Place'],
        street_address_alias: ['360 Hubbard', '360 West Hubbard Street']
      },
      {
        id: '9373d8ec-883f-51a5-962d-ca757f5cb259',
        lat: 41.88969,
        lon: -87.6188,
        city: 'Chicago',
        state: 'IL',
        zip_code: '60611',
        year_built: 2015,
        number_units: 399,
        building_name: 'North Water Apartments',
        street_address: '340 East North Water Street',
        building_name_alias: ['North Water', 'North Water Apartments'],
        street_address_alias: ['340 East North Water Street']
      },
      {
        id: '120666d1-166f-5c34-a478-cabbdea76289',
        lat: 41.88425,
        lon: -87.62882,
        city: 'Chicago',
        state: 'IL',
        zip_code: '60601',
        year_built: 2015,
        number_units: 690,
        building_name: 'Marquee at Block 37',
        street_address: '25 West Randolph Street',
        building_name_alias: [
          'Southgate Shopping Center',
          '25 West Randolph St.',
          'Marquee at Block 37'
        ],
        street_address_alias: [
          '25 Randolph',
          '25 West Randolph Drive',
          '25 West Randolph Street',
          '25 East Randolph Street'
        ]
      },
      {
        id: '1e33d4fa-7c06-5e37-a7de-8f3dc692a983',
        lat: 41.89373,
        lon: -87.63384,
        city: 'Chicago',
        state: 'IL',
        zip_code: '60654',
        year_built: 2017,
        number_units: 445,
        building_name: 'The Gallery on Wells',
        street_address: '637 North Wells Street',
        building_name_alias: ['The Gallery On Wells', 'Gallery on Wells', 'The Gallery on Wells'],
        street_address_alias: ['637 North Wells Street', '637 Wells', '637 North Wells']
      },
      {
        id: '3e89f84b-524b-55ef-bbbe-fe004cf074e1',
        lat: 41.88611,
        lon: -87.62499,
        city: 'Chicago',
        state: 'IL',
        zip_code: '60601',
        year_built: 2016,
        number_units: 402,
        building_name: 'MILA',
        street_address: '200 North Michigan Avenue',
        building_name_alias: ['MILA'],
        street_address_alias: ['200 North Michigan Avenue']
      },
      {
        id: '588b494f-91f4-5961-8483-f78d6808c915',
        lat: 41.88729,
        lon: -87.61852,
        city: 'Chicago',
        state: 'IL',
        zip_code: '60601',
        year_built: 2013,
        number_units: 515,
        building_name: 'Coast at Lakeshore East',
        street_address: '345 East Wacker Drive',
        building_name_alias: ['Southgate Shopping Center', 'Coast at Lakeshore East'],
        street_address_alias: ['345 Wacker', '345 Wacker Drive', '345 East Wacker Drive']
      },
      {
        id: '30cebca6-efd2-5222-adfc-b9d1a5681f6f',
        lat: 41.89102,
        lon: -87.63494,
        city: 'Chicago',
        state: 'IL',
        zip_code: '60654',
        year_built: 2015,
        number_units: 188,
        building_name: 'Cortland River North',
        street_address: '220 West Illinois Street',
        building_name_alias: ['Cortland River North'],
        street_address_alias: ['220 West Illinois', '220 West Illinois Street', '220 Illinois']
      }
    ],
    feature_flags: [
      'price_recommendation',
      'leased_percent',
      'make_public',
      'make_organization_visible',
      'thumbnail_customization'
    ]
  },
  {
    name: 'Sample - Suburban Apartments',
    subject: {
      id: 'e8769b06-1334-5ab6-b9c6-6dfccbf9ea78',
      lat: 42.05818,
      lon: -87.79847,
      city: 'Glenview',
      state: 'IL',
      zip_code: '60025',
      year_built: 2015,
      number_units: 239,
      building_name: 'Reserve at Glenview',
      street_address: '195 Waukegan Road',
      building_name_alias: ['Reserve At Glenview', 'Reserve at Glenview'],
      street_address_alias: ['195 Waukegan Road']
    },
    comparable_addresses: [
      {
        id: '4a3c589c-a7de-5233-9d95-8064ef4048db',
        lat: 42.01038,
        lon: -87.82397,
        city: 'Park Ridge',
        state: 'IL',
        zip_code: '60068',
        year_built: 2015,
        number_units: 115,
        building_name: 'Park 205',
        street_address: '205 West Touhy Avenue',
        building_name_alias: ['Park 205'],
        street_address_alias: ['West Touhy Avenue', '205 Touhy Avenue', '205 West Touhy Avenue']
      },
      {
        id: 'cd98d382-e7b3-5347-9bc8-b4204cf0e4b8',
        lat: 42.1105,
        lon: -87.87075,
        city: 'Northbrook',
        state: 'IL',
        zip_code: '60062',
        year_built: 2014,
        number_units: 290,
        building_name: 'Arrive Glenview',
        street_address: '2550 Waterview Drive',
        building_name_alias: ['Arrive Glenview'],
        street_address_alias: ['2550 Waterview Drive']
      },
      {
        id: 'efda977a-7cf6-5486-a81a-6ccc2fa2d1a3',
        lat: 42.07568,
        lon: -87.70865,
        city: 'Wilmette',
        state: 'IL',
        zip_code: '60091',
        year_built: 2017,
        number_units: 75,
        building_name: 'The Residences of Wilmette',
        street_address: '617 Green Bay Road',
        building_name_alias: ['The Residences of Wilmette'],
        street_address_alias: ['617 Green Bay Road']
      },
      {
        id: '5eae9cc7-43e5-52a1-a7ed-6bfcf4cf0f14',
        lat: 42.03969,
        lon: -87.88541,
        city: 'Des Plaines',
        state: 'IL',
        zip_code: '60016',
        year_built: 2019,
        number_units: 113,
        building_name: 'Ellison',
        street_address: '1555 Ellinwood Avenue',
        building_name_alias: ['Ellison'],
        street_address_alias: ['1555 Ellinwood Avenue', '1555 Ellinwood']
      },
      {
        id: 'a83d1e4d-1030-5a97-9fe4-2eda4aac8911',
        lat: 42.14069,
        lon: -87.79513,
        city: 'Northbrook',
        state: 'IL',
        zip_code: '60062',
        year_built: 2016,
        number_units: 345,
        building_name: 'TGM NorthShore',
        street_address: '770 Skokie Boulevard',
        building_name_alias: ['TGM Northshore', '770 Skokie Boulevard', 'TGM NorthShore'],
        street_address_alias: ['770 Skokie Boulevard']
      },
      {
        id: '58430204-f131-516e-8aee-879fad7fd2b6',
        lat: 42.04274,
        lon: -87.88346,
        city: 'Des Plaines',
        state: 'IL',
        zip_code: '60016',
        year_built: 2011,
        number_units: 144,
        building_name: 'Renew Five Ninety Five',
        street_address: '595 South Des Plaines River Road',
        building_name_alias: [
          'Renew Five Ninety Five',
          'Kingston Pointe',
          'Kingston Pointe Apartments'
        ],
        street_address_alias: [
          '595 South River Road',
          '595 South Des Plaines River Road',
          '1646 River Street'
        ]
      },
      {
        id: '6e89f911-a526-59e3-b004-3b0b5a491a36',
        lat: 42.1066,
        lon: -87.7724,
        city: 'Chicago',
        state: 'IL',
        zip_code: '60614',
        year_built: null,
        number_units: null,
        building_name: 'Arden Of Lincoln Park',
        street_address: '2725 Ashland',
        building_name_alias: ['Arden Of Lincoln Park'],
        street_address_alias: ['2725 North Ashland Avenue', '2725 Ashland']
      },
      {
        id: '0af252ec-f3d1-5445-bd27-34ad46283b04',
        lat: 42.04012,
        lon: -87.79413,
        city: 'Morton Grove',
        state: 'IL',
        zip_code: '60053',
        year_built: 2021,
        number_units: 250,
        building_name: 'The Residences at Sawmill Station',
        street_address: '6701 Dempster Street',
        building_name_alias: ['The Residences at Sawmill Station'],
        street_address_alias: ['6701 Dempster Street', '6701 West Dempster Street']
      }
    ],
    feature_flags: [
      'price_recommendation',
      'make_public',
      'make_organization_visible',
      'thumbnail_customization'
    ]
  }
]
